/**
 * Returns a cryptographically secure random integer between 0 (inclusive)
 * and maxExclusive (exclusive).
 */
/* global globalThis */
export const getSecureRandomInt = (maxExclusive) => {
  if (!Number.isInteger(maxExclusive) || maxExclusive <= 0) {
    throw new Error("maxExclusive must be a positive integer");
  }

  const cryptoObj = globalThis?.crypto;

  if (!cryptoObj?.getRandomValues) {
    throw new Error("Secure random generation is not supported in this environment");
  }

  const maxUint32 = 0x100000000;
  const limit = Math.floor(maxUint32 / maxExclusive) * maxExclusive;
  const randomValues = new Uint32Array(1);

  let randomValue = 0;
  do {
    cryptoObj.getRandomValues(randomValues);
    randomValue = randomValues[0];
  } while (randomValue >= limit);

  return randomValue % maxExclusive;
};
